import { useState } from "react";
import styles from "./EnrollView.module.scss";
import { View, ViewHeader } from "@/components";
import { EnrollPlatformToolbar } from "../enroll-platform-toolbar";
import { EnrollmentInstructions } from "../enrollment-instructions";
import { ENROLL_INSTRUCTIONS_BY_PLATFORM } from "../../_constants/enroll-steps.data";
import type { EnrollPlatform } from "../../_constants/enroll-platforms.const";

export const EnrollView = () => {
  const [platform, setPlatform] = useState<EnrollPlatform>("macos");
  const steps = ENROLL_INSTRUCTIONS_BY_PLATFORM[platform];

  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Enroll"
          description="Register new devices and onboard hardware into your organization.<br />Use this section to manage enrollment flows and device provisioning."
        />

        <EnrollPlatformToolbar platform={platform} onPlatformChange={setPlatform} />

        <EnrollmentInstructions key={platform} steps={steps} />
      </div>
    </View>
  );
};
